import './../../scss/theme/components/testimonial.scss';

window.addEventListener('DOMContentLoaded', () => {

  const slides = document.querySelectorAll('.swiper-wrapper .swiper-slide');

  const swiper = new Swiper('.testimonial_swiper', {
    loop: true,
    spaceBetween: 120,
    autoHeight: false,
    enabled: slides.length > 1,
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

});
